import React, { useEffect, useState } from "react";
import { IonRow, IonCol, IonInput, IonButton, IonIcon, IonCard } from "@ionic/react";
import { calculator, options, close } from "ionicons/icons";
import styles from "../../Css/Search.module.scss";
import ModalFilters from './ModalFilters';
import Calculator from "../../../../General/Components/Calculator";

const SearchDetail = ({
    fnSearch,
    fnSearchAll,
    fnFilterName,
    physicTakeHeaderCode
}) => {
    const [isOpenFilters, setIsOpenFilters] = useState(false);
    const [isOpenCalculator, setIsOpenCalculator] = useState(false);

    useEffect(() => {
        // eslint-disable-next-line
    }, []);

    const searchAll = () => {
        document.getElementById("name").value = "";
        fnFilterName('');
    };

    function openModal(status) {
        setIsOpenFilters(status);
    }

    function fnOpenCalculator(status) {
        setIsOpenCalculator(status);
    }

    function filter(filters, type){
        if(type === 1){
            fnSearch(filters);
            openModal(false);
        } else {
            fnSearchAll();
            openModal(false);
        }
    }

    return (
        <div className={styles.center}>
            <IonCard className={styles.card}>
                <IonRow>
                    <IonCol size="12">
                        <div className={styles.search}>
                            <IonRow>
                                <IonCol size="2" className={styles.iconSearch}>
                                    <IonIcon icon={options} onClick={() => openModal(true)} />
                                </IonCol>
                                <IonCol size="8">
                                    <IonInput onKeyUp={(e) => fnFilterName(e)} name="name" id="name" type="text" placeholder="Nombre Artículo" />
                                </IonCol>
                                <IonCol size="2" className={styles.iconSearch}>
                                    {(document.getElementById("name") && document.getElementById("name").value !== "") && (
                                        <IonIcon icon={close} onClick={() => searchAll()} />
                                    )}
                                </IonCol>
                            </IonRow>
                        </div>
                    </IonCol>
                    <IonCol size="10">
                        
                    </IonCol>
                    <IonCol size="2">
                        <IonButton onClick={() => fnOpenCalculator(true)} style={{display:'flex'}}>
                            <IonIcon icon={calculator} />
                        </IonButton>
                    </IonCol>
                </IonRow>
            </IonCard>
            <ModalFilters 
                open={isOpenFilters}
                fn={openModal}
                filter={filter}
                physicTakeHeaderCode={physicTakeHeaderCode}
            />
            <Calculator
                open={isOpenCalculator}
                fnClose={fnOpenCalculator}
            />
        </div>
    );
};

export default SearchDetail;








